export class Feature {
  /** Code is the id – unique identifier for the feature */
  code: string = '';
  name: string = '';

  constructor(raw?: Partial<Feature> & { id?: string }) {
    if (raw) {
      this.code = raw.code ?? raw.id ?? '';
      this.name = raw.name ?? '';
    }
  }
}
